/**
 * @generated SignedSource<<ca33387320ed4e7d2a38bf948b133c23>>
 * @relayHash b59c317c81594bd78b817cb2949ca773
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d49201a9a1b4bdc49c49dbd96415d207ae22d20b5facee10a7048f6f5539566

import type { ConcreteRequest, Query } from 'relay-runtime';
export type requireSuperBatchFrontendResourceRenderQuery$variables = Record<PropertyKey, never>;
export type requireSuperBatchFrontendResourceRenderQuery$data = {
  readonly internalFrontendResource: {
    readonly resourceList: ReadonlyArray<{
      readonly attributes: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined>;
      readonly type: string | null | undefined;
      readonly url: string | null | undefined;
    }>;
  } | null | undefined;
};
export type requireSuperBatchFrontendResourceRenderQuery = {
  response: requireSuperBatchFrontendResourceRenderQuery$data;
  variables: requireSuperBatchFrontendResourceRenderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "FrontendResourceRenderResponse",
    "kind": "LinkedField",
    "name": "internalFrontendResource",
    "plural": false,
    "selections": [
      {
        "concreteType": "FrontendResource",
        "kind": "LinkedField",
        "name": "resourceList",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "MapOfStringToString",
            "kind": "LinkedField",
            "name": "attributes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requireSuperBatchFrontendResourceRenderQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "requireSuperBatchFrontendResourceRenderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b59c317c81594bd78b817cb2949ca773",
    "id": "4d49201a9a1b4bdc49c49dbd96415d207ae22d20b5facee10a7048f6f5539566",
    "metadata": {},
    "name": "requireSuperBatchFrontendResourceRenderQuery",
    "operationKind": "query",
    "text": "query requireSuperBatchFrontendResourceRenderQuery{internalFrontendResource{resourceList{type,url,attributes{key,value}}}}"
  }
};
})();

(node as any).hash = "8a3367aeae260202f4cadd323073938c";

export default node;
